/* eslint-disable @typescript-eslint/no-empty-function */

import { Component, Inject, Input, OnInit } from '@angular/core';
import { ICbicContentMst } from 'app/entities/cbic-content-mst/cbic-content-mst.model';
import { UtilsService } from 'app/core/util/view-file.component';
import { Text } from 'app/entities/cbic-content-mst/view-content/table/table-data.model';
import { GSTComponent } from 'app/gst/gst.component';
import { ChangeLanguageService } from 'app/core/util/change-language.service';

@Component({
  selector: 'cbic-pop-up-notification',
  templateUrl: './pop-up-notification.component.html',
  styleUrls: ['./pop-up-notification.component.scss']
})
export class PopUpNotificationComponent{
  @Input() cbicContentMst?: ICbicContentMst[];
  @Input() modelRef:any;
  popupTitle: Text;
 
  output:any=[]
  res:any;
  constructor(public utils: UtilsService,
        public flag:ChangeLanguageService

  ) {
    this.popupTitle = {En: "Notification", Hi:"Notification"};
    console.log('demo------------------',this.flag.getLanguage());
    this.res= localStorage.getItem("homeres");
    console.log('res--------------------',this.res)
    this.output=JSON.parse(this.res);
    console.log('res--------------------',JSON.parse(this.res))
    console.log("internalDocMappings------------",this.output.body[2]?.internalDocMappings[0].cbicDocMstDTO.filePathHi)
    console.log('cbicContentMst------------------',this.cbicContentMst)
  }

  getContentMst(): ICbicContentMst[] | null | undefined{
    return this.cbicContentMst;
  }

  ViewPdf(filePath: any) {
    
      this.utils.viewOpenning(filePath);
    
  }

  
}
